import { STABLES_PER_CHAIN_BY_ADDRESS } from '@/constants/addresses';

import { isTokenAddressNativeAsset, isTokenAddressWrappedNativeAsset } from './multichain';

/**
 * Determines if the current token pair being swapped are both stablecoins.
 *
 * @param chainId - The current chainId
 * @param sellTokenAddress - The address of the sell token
 * @param buyTokenAddress - The address of the buy token
 */
export function isStableToStableSwap(
  chainId: number | undefined,
  sellTokenAddress: string | undefined,
  buyTokenAddress: string | undefined,
) {
  if (chainId !== 1 && chainId !== 137) return false;

  const stableAddressesOnCurrentChain = chainId ? STABLES_PER_CHAIN_BY_ADDRESS[chainId] : {};

  return (
    sellTokenAddress &&
    !!stableAddressesOnCurrentChain[sellTokenAddress] &&
    buyTokenAddress &&
    !!stableAddressesOnCurrentChain[buyTokenAddress]
  );
}

export function isWrap(
  sellTokenAddress: string,
  buyTokenAddress: string,
  chainId: number,
): boolean {
  return (
    !!(
      isTokenAddressNativeAsset(sellTokenAddress, chainId) &&
      isTokenAddressWrappedNativeAsset(buyTokenAddress, chainId)
    ) ||
    !!(
      isTokenAddressWrappedNativeAsset(sellTokenAddress, chainId) &&
      isTokenAddressNativeAsset(buyTokenAddress, chainId)
    )
  );
}
